import Vue from 'vue'
Vue.filter('transAmount',(num)=>{
	let count = num/1000000
	return count
})



// WEBPACK FOOTER //
// ./src/filter/index.js